import { alpha, makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  button: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 1000,
    border: `2px solid ${alpha(theme.palette.common.black, 0.2)}`,
    borderRadius: 4,
    minWidth: 0,
    padding: 6,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
      boxShadow: 'none',
    },
  },
  mapContainer: {
    height: '100%',
    width: '100%',
    minHeight: 300,
  },
}))
